import { FLAGS, isFeatureEnabled } from 'affiny-core/helpers/featureToggle';
import { authActions } from 'affiny-core/modules/auth/actions';
import { selectIovationBlackbox } from 'affiny-core/redux/selectors/configSelectors';
import { linkingService } from 'affiny-core/services/linking/linking';
import { storageService } from 'affiny-core/services/storage/storage';
import { call, put, select } from 'redux-saga/effects';
import { isWeb } from 'affiny-core/helpers/targetCheck/targetCheck';
import { AuthResource } from './resources/auth.resource';

export function* getRefreshToken() {
  return yield call([storageService, 'getRefreshToken']);
}

export function* storeSessionOrigin() {
  const sessionOrigin = yield call([linkingService, 'getSessionOrigin']);

  if (!sessionOrigin) return null;

  yield call([storageService, 'persistSessionOrigin'], sessionOrigin);

  return;
}

export function* getSessionOrigin() {
  const sessionOrigin = yield call([storageService, 'getSessionOrigin']);

  if (!sessionOrigin) return null;

  return sessionOrigin;
}

export function* storeRefreshTokenDebug() {
  const refreshToken = yield call([linkingService, 'getRefreshToken']);

  if (!refreshToken) return null;

  yield call([storageService, 'persistRefreshToken'], refreshToken);

  return;
}

export function* refreshAuthentication() {
  // eslint-disable-next-line no-useless-catch
  try {
    if (
      isFeatureEnabled(FLAGS.LOGIN_FROM_QUERY_PARAMS_DEBUG) ||
      process.env.NODE_ENV === 'development'
    ) {
      yield* storeRefreshTokenDebug();
    }

    yield* storeSessionOrigin();

    let blackbox = yield select(selectIovationBlackbox);

    if (
      (!blackbox || blackbox === '') &&
      process.env.NODE_ENV !== 'development'
    ) {
      const isOnWam = isWeb();

      const MODULES = {
        wam: require('affiny-core/modules/configurations/saga'),
        rn: 'Not implemented yet',
      };
      const platform = isOnWam ? 'wam' : 'rn';

      const module = MODULES[platform];

      if (module !== 'Not implemented yet') {
        yield* module.generateBlackboxString();
      }

      blackbox = yield select(selectIovationBlackbox);
    }

    const refreshToken = yield* getRefreshToken();

    if (!refreshToken) return yield put(authActions.logout());

    // The sessionOrigin is stored thanks to an url parameter
    // we need to access the stored value because when the user navigates the url parameter will go away
    const sessionOrigin = yield* getSessionOrigin();
    const token = yield call(
      AuthResource.refreshWithToken,
      refreshToken,
      sessionOrigin,
      blackbox
    );

    yield put(authActions.loginSuccess(token));
  } catch (e) {
    // This case can happen when the user installs the app for the first time (app)
    // or when the user has cleaned his cookies (web)
    throw e;
  }
}
